// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yearnavbar {
  font-size: 1.5rem;
}
.yearnavbar .nav-link {
  color: var(--primary_color) !important;
}

.sharecard {
  width: 300px;
  padding: 10px;
}

.sharetitle {
  font-size: 20px;
  font-weight: bold;
}

.sharecontent {
  font-style: 12px;
}

@media (max-width: 1200px) {
  .sharearea {
    justify-content: center;
  }
  .featured {
    justify-content: center;
  }
  .yearnavbar {
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/share/styles/share.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;AAAI;EACI,sCAAA;AAER;;AACA;EACI,YAAA;EACA,aAAA;AAEJ;;AACA;EACI,eAAA;EACA,iBAAA;AAEJ;;AAAA;EACI,gBAAA;AAGJ;;AADA;EACI;IACI,uBAAA;EAIN;EAFE;IACI,uBAAA;EAIN;EAFE;IACI,eAAA;EAIN;AACF","sourcesContent":[".yearnavbar {\n    font-size: 1.5rem;\n    .nav-link {\n        color: var(--primary_color) !important;\n    }\n}\n.sharecard {\n    width: 300px;\n    padding: 10px;\n}\n\n.sharetitle{\n    font-size: 20px;\n    font-weight: bold;\n}\n.sharecontent{\n    font-style: 12px;\n}\n@media (max-width:1200px) {\n    .sharearea{\n        justify-content: center;\n    }\n    .featured {\n        justify-content: center;\n    }\n    .yearnavbar {\n        font-size: 1rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
